interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
  life: number;
  max: number;
  size: number;
  color: string;
  ring: boolean;
}

/** Lightweight particle bursts shared by the arcade games. Coordinates are the game's logical units. */
export class Particles {
  private list: Particle[] = [];
  constructor(public reducedMotion = false) {}

  burst(x: number, y: number, color: string, count = 10, speed = 160, life = 0.45, size = 3): void {
    const n = this.reducedMotion ? Math.ceil(count / 3) : count;
    for (let i = 0; i < n; i++) {
      const a = Math.random() * Math.PI * 2;
      const s = speed * (0.3 + Math.random() * 0.9);
      this.list.push({ x, y, vx: Math.cos(a) * s, vy: Math.sin(a) * s, life, max: life, size, color, ring: false });
    }
  }

  ring(x: number, y: number, color: string, radius = 40, life = 0.4): void {
    if (this.reducedMotion) return;
    this.list.push({ x, y, vx: 0, vy: 0, life, max: life, size: radius, color, ring: true });
  }

  clear(): void {
    this.list = [];
  }

  update(dt: number): void {
    for (const p of this.list) {
      p.life -= dt;
      p.x += p.vx * dt;
      p.y += p.vy * dt;
      const k = Math.pow(0.88, dt * 60);
      p.vx *= k;
      p.vy *= k;
    }
    this.list = this.list.filter((p) => p.life > 0);
  }

  draw(g: CanvasRenderingContext2D): void {
    for (const p of this.list) {
      const k = p.life / p.max;
      g.globalAlpha = k;
      if (p.ring) {
        g.strokeStyle = p.color;
        g.lineWidth = 3 * k;
        g.beginPath();
        g.arc(p.x, p.y, p.size * (1 - k) + 6, 0, Math.PI * 2);
        g.stroke();
      } else {
        g.fillStyle = p.color;
        g.fillRect(p.x - p.size / 2, p.y - p.size / 2, p.size, p.size);
      }
    }
    g.globalAlpha = 1;
  }
}
